import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQAccordion() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-6 md:px-12 md:py-7" data-id="element-46" data-mp="26b0cb7n1a9xi">
      <h2 className="text-center font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[32px]" data-id="element-47" data-mp="21hfepgpcrhyu">
        Frequently asked questions
      </h2>
      <div className="mt-3 divide-y divide-line overflow-hidden rounded-md border border-line bg-white" data-id="element-48" data-mp="2a9hd79fv2o6h">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-49" data-mp="2k9qcwx92arqm" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left md:py-2.5" data-id="element-50" data-mp="2k9gld58dccit">
                <span className="font-heading text-[14px] font-bold leading-tight text-navy md:text-[15px]" data-id="element-51" data-mp="2zrmh67jb0klu">{f.q}</span>
                <ChevronDownIcon className={`h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} strokeWidth={3} aria-hidden data-id="element-52" data-mp="38uduydznjsgn" />
              </button>
              <AnimatePresence initial={false} data-id="element-53" data-mp="3ijxfdo30judm">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-54" data-mp="3nhyyua4cpvpm">
                    <p className="px-3 pb-2.5 text-[14px] leading-[1.35] text-ink md:text-[15px]" data-id="element-55" data-mp="22705kito2358">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}